define('LNRS/Components/Forms/ValidationOptions',["jquery"], function ($) {
    "use strict";

    var instance = null;
    var defaultOptions = null;
    var initialize = function () {
        defaultOptions = {
            validClass: "has-success",
            errorClass: "has-error",
            highlight: function (element, errorClass, validClass) {
                $(element).closest(".form-group")
                    .removeClass(validClass)
                    .addClass("has-error");
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).closest(".form-group")
                    .removeClass("has-error")
                    .addClass(validClass);
            }
        };
    };

    function ValidationOptions() {
        if (instance !== null) {
            throw new Error("Cannot instantiate more than one ValidationOptions, use ValidationOptions.getInstance()");
        }
        initialize();
    }

    ValidationOptions.getInstance = function () {
        if (instance === null) {
            instance = new ValidationOptions();
        }
        return instance;
    };

    ValidationOptions.prototype.getDefaultOptions = function () {
        return defaultOptions;
    };

    ValidationOptions.prototype.getUnobtrusiveOptions = function () {
        return {
            errorClass: defaultOptions.errorClass,
            validClass: defaultOptions.validClass
        }
    };

    return ValidationOptions.getInstance();
});
